<div class="benefits-list">
    <div class="input-group mb-2">
        <input type="text" class="form-control" [(ngModel)]="newBenefit" [disabled]="disabled"
            placeholder="Escribe un beneficio..." (keydown)="onKeydown($event)" />
        <button type="button" class="btn btn-outline-colonial" [disabled]="disabled || !newBenefit.trim()"
            (click)="addBenefit()">
            <span class="material-symbols-outlined">add</span>
        </button>
    </div>

    <ul class="list-group" *ngIf="benefits.length > 0">
        <li class="list-group-item d-flex justify-content-between align-items-center"
            *ngFor="let benefit of benefits; let i = index">
            <span>{{ benefit }}</span>
            <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="disabled"
                (click)="removeBenefit(i)">
                <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
            </button>
        </li>
    </ul>

    <p class="text-muted small mt-2 mb-0" *ngIf="benefits.length === 0">
        No hay beneficios agregados.
    </p>
</div>